var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"accesskey",attrs:{"id":_vm.id || _vm.target,"href":_vm.href || '#',"accesskey":_vm.accesskey,"aria-label":_vm.ariaLabel},on:{"click":function($event){$event.preventDefault();return _vm.scrollToTarget.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }